const baseUrl = process.env.REACT_APP_BASE_URL

const headers = new Headers({
  'Content-type': 'application/json',
})

const apiGet = (url) =>
  fetch(`${baseUrl}/${url}`, { headers })
    .then((res) => {
      if (res.status === 401) {
        return Promise.reject(res)
      }
      return res.json()
    })
    .then((res) => {
      if (res.data.error) {
        return { error: res.data.error[0] }
      }
      return res
    })
    .catch((err) => {
      console.error(err)
      if (err.status === 401) {
        return { error: 'Not Authorized!' }
      }
      return { error: 'Something went wrong' }
    })

const apiPost = (url, data) =>
  fetch(`${baseUrl}/${url}`, {
    method: 'POST',
    body: JSON.stringify(data),
    headers
  })
    .then((res) => res.json())
    .then((res) => {
      if (res.data.error) {
        return { error: res.data.error[0] }
      }
      return res
    })
    .catch((err) => {
      console.error(err)
      return { error: 'Something Went wrong!' }
    })

export { headers, apiGet, apiPost }
